import { action } from 'easy-peasy';
import { IActionSetLocalAdmin } from '../types';

const setLocalAdmin: IActionSetLocalAdmin = action((state, payload) => {
  state.current = payload;
});

export default setLocalAdmin;
